import { render, staticRenderFns } from "./XChatPin.vue?vue&type=template&id=ccb07f12"
import script from "./XChatPin.vue?vue&type=script&lang=js"
export * from "./XChatPin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports